(function () {
  angular.module("akitabox.ui.dialogs.workOrder.cancel", [
    "akitabox.core.constants",
    "akitabox.core.services.workOrder",
    "akitabox.core.toast",
  ]);
})();
